import React, { Component } from "react";
import { Select, Spin } from "antd";
import axios from "axios";

const { Option } = Select;

class SelectUsuariosItem extends Component {
  state = { opciones: [], cargando: false };

  componentDidMount() {
    this.cargarOpciones();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.empresaId !== this.props.empresaId) {
      this.cargarOpciones();
    }
  }

  cargarOpciones = () => {
    const { headersToken, empresaId } = this.props;
    if (!empresaId) return;
    this.setState({ cargando: true });
    axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId },
        { headers: headersToken },
      )
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({ opciones: res.data });
        }
      })
      .catch(() => {})
      .finally(() => this.setState({ cargando: false }));
  };

  render() {
    const { value, onChange, placeholder, style, width, disabled } = this.props;
    const { opciones, cargando } = this.state;

    return (
      <Select
        showSearch
        mode="multiple"
        allowClear
        disabled={disabled}
        placeholder={placeholder ?? "Selecciona usuarios"}
        value={value}
        onChange={onChange}
        loading={cargando}
        style={{ width: width ?? "100%", ...style }}
        filterOption={(input, opt) =>
          opt.children.toLowerCase().includes(input.toLowerCase())
        }
        notFoundContent={cargando ? <Spin size="small" /> : "Sin resultados"}
      >
        {opciones.map((u) => (
          <Option key={u._id} value={u._id}>
            {`${u.nombre} ${u.apellidoPaterno ?? ""}`.trim()}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectUsuariosItem;
